import { type ActionMethods, type PageTypes, type UserSelfPageData } from '.';
import useActiveSessionsPageData from './ActiveSessions/useActiveSessionsPageData';
import useAuthenticatorPageData from './Authenticator/useAuthenticatorPageData';
import useChangePasswordPageData from './ChangePassword/useChangePasswordPageData';
import useEditProfilePageData from './EditProfile/useEditProfilePageData';
import useViewProfilePageData from './ViewProfile/useViewProfilePageData';
import useWebAuthnSettingsPageData from './WebAuthnSettings/useWebAuthnSettingsPageData';

type useUserSelfPagesProps = {
    actions: ActionMethods;
    onMenuItemClicked: (pageType: PageTypes) => void;
};
const useUserSelfPages = ({ actions, onMenuItemClicked }: useUserSelfPagesProps) => {
    const pages: UserSelfPageData[] = [
        useViewProfilePageData({ actions, onMenuItemClicked }),
        useEditProfilePageData(actions),
        useAuthenticatorPageData(actions),
        useChangePasswordPageData(actions),
        useWebAuthnSettingsPageData(actions),
        useActiveSessionsPageData(actions),
    ];

    return pages;
};

export default useUserSelfPages;
